"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var BaseModule_1 = require("./BaseModule");
/**
 * Enables resize of image by dragging the corners of an image
 *
 * @export
 * @class Resize
 * @extends {BaseModule}
 */
var Resize = /** @class */ (function (_super) {
    __extends(Resize, _super);
    function Resize(resize) {
        var _this = _super.call(this, resize) || this;
        _this.listeners = {
            onMouseDown: _this.onMouseDown(),
            onMouseDrag: _this.onMouseDrag(),
            onMouseRelease: _this.onMouseRelease()
        };
        return _this;
    }
    Resize.prototype.onMouseDown = function () {
        var self = this;
        return function (event) {
            // Create the box for resizing
            self.resizeBox = event.target;
            self.clickPosition = event.clientX;
            self.originalWidth = self.img.width || self.img.naturalWidth;
            self.setCursorStyle(self.resizeBox.style.cursor);
            document.addEventListener('mousemove', self.listeners.onMouseDrag);
            document.addEventListener('mouseup', self.listeners.onMouseRelease);
        };
    };
    Resize.prototype.onMouseDrag = function () {
        var self = this;
        return function (event) {
            if (!self.img)
                return;
            var deltaX = event.clientX - self.clickPosition;
            // Left-size resize handler - shrink image
            if (self.resizeBox === self.boxes[0] || self.resizeBox === self.boxes[3])
                self.img.width = Math.round(self.originalWidth - deltaX);
            else
                self.img.width = Math.round(self.originalWidth + deltaX);
            self.imageResize.onUpdate();
        };
    };
    Resize.prototype.onMouseRelease = function () {
        var self = this;
        return function (event) {
            self.setCursorStyle('');
            document.removeEventListener('mousemove', self.listeners.onMouseDrag);
            document.removeEventListener('mouseup', self.listeners.onMouseRelease);
        };
    };
    Resize.prototype.createBox = function (cursorType) {
        var box = document.createElement('div');
        var self = this;
        lodash_1.assign(box.style, this.options.handleStyles);
        box.style.cursor = cursorType;
        box.style.width = this.options.handleStyles.width + 'px';
        box.style.height = this.options.handleStyles.height + 'px';
        box.addEventListener('mousedown', self.listeners.onMouseDown, false);
        this.overlay.appendChild(box);
        return box;
    };
    Resize.prototype.positionBoxes = function () {
        var xOffset = (-parseFloat(this.options.handleStyles.width) / 2) + 'px';
        var yOffset = (-parseFloat(this.options.handleStyles.height) / 2) + 'px';
        this.boxes[0].style.left = xOffset;
        this.boxes[0].style.top = yOffset;
        this.boxes[1].style.right = xOffset;
        this.boxes[1].style.top = yOffset;
        this.boxes[2].style.right = xOffset;
        this.boxes[2].style.bottom = yOffset;
        this.boxes[3].style.left = xOffset;
        this.boxes[3].style.bottom = yOffset;
    };
    Resize.prototype.onCreate = function () {
        this.boxes = [
            this.createBox('nwse-resize'),
            this.createBox('nesw-resize'),
            this.createBox('nwse-resize'),
            this.createBox('nesw-resize') // Bottom left
        ];
        this.positionBoxes();
    };
    Resize.prototype.onDestroy = function () {
        this.setCursorStyle('');
    };
    Resize.prototype.onUpdate = function () {
    };
    Resize.prototype.setCursorStyle = function (cursorStyle) {
        document.body.style.cursor = cursorStyle;
        this.img.style.cursor = cursorStyle;
    };
    return Resize;
}(BaseModule_1.BaseModule));
exports.Resize = Resize;
//# sourceMappingURL=Resize.js.map